import { getToken } from './user-service';
import { getDownloadURL, getStorage, ref } from "firebase/storage";
import fire from "_utils/firebase";

const errorString = (response) => {
    return (
        "Error " + response.status + ": " + response.statusText
    )
}

export const getArrivalsOnlyBookings = async (props) => {

    const token = await getToken();
    const url = "/api/v1/bookings/bookingAnalytics/" +
        props.departureAirport +
        "/counts?date=" +
        props.startDate +
        "&endDate=" +
        props.endDate +
        "&type=two_airports&range=year&byType=none&airline=&endDate=&byHour=&source=" +
        props.filter +
        "&byFlight=&forecast=&destinationAirport=" +
        props.arrivalAirport +
        "&breakDownByRequest=destination_requested"

    return new Promise(async (resolve, reject) => {

        try {
            const response = await fetch(url, { method: 'GET', headers: { "Firebase-UID": token } });
            let json = await response.json();

            if (response.status >= 400 && response.status < 600) {
                throw (new Error(errorString(response)))
            }

            // console.log('arrivals only json ', json)
            resolve(json);

        } catch (e) {
            reject(new Error(e.message));
        }
    });
};

export const getDepartureOnlyBookings = async (props) => {

    const token = await getToken();
    const url = "/api/v1/bookings/bookingAnalytics/" +
        props.departureAirport +
        "/counts?date=" +
        props.startDate +
        "&endDate=" +
        props.endDate +
        "&type=two_airports&range=year&byType=none&airline=&endDate=&byHour=&source=" +
        props.filter +
        "&byFlight=&forecast=&destinationAirport=" +
        props.arrivalAirport +
        "&breakDownByRequest=origin_requested"

    // console.log('getting departures only ', url);

    return new Promise(async (resolve, reject) => {

        try {
            const response = await fetch(url, { method: 'GET', headers: { "Firebase-UID": token } });
            let json = await response.json();

            if (response.status >= 400 && response.status < 600) {
                throw (new Error(errorString(response)))
            }

            // console.log('only departure json ', json)
            resolve(json);

        } catch (e) {
            reject(new Error(e.message));
        }
    });
};

export const departureAndArrivalBookings = async (props) => {

    const token = await getToken();
    const url = "/api/v1/bookings/bookingAnalytics/" +
        props.departureAirport +
        "/counts?date=" +
        props.startDate +
        "&endDate=" +
        props.endDate +
        "&type=two_airports&range=year&byType=none&airline=&endDate=&byHour=&source=" +
        props.filter +
        "&byFlight=&forecast=&destinationAirport=" +
        props.arrivalAirport + "&breakDownByRequest=both_requested"

    return new Promise(async (resolve, reject) => {

        try {
            const response = await fetch(url, { method: 'GET', headers: { "Firebase-UID": token } });
            let json = await response.json();

            if (response.status >= 400 && response.status < 600) {
                throw (new Error(errorString(response)))
            }

            // console.log('both requested json ', json)
            resolve(json);

        } catch (e) {
            reject(new Error(e.message));
        }
    });
};

export const getTwoAirportBookingsPortal = async (props) => {

    const token = await getToken();

    const url = "/api/v1/bookings/bookingAnalytics/" +
        props.departureAirport +
        "/counts?date=" +
        props.startDate +
        "&endDate=" +
        props.endDate +
        "&type=two_airports&range=year&byType=P&airline=&endDate=&byHour=&source=P&byFlight=&forecast=&destinationAirport=" +
        props.arrivalAirport

    // console.log('getting airport bookings portal ', url);

    return new Promise(async (resolve, reject) => {

        try {
            const response = await fetch(url, { method: 'GET', headers: { "Firebase-UID": token } });
            let json = await response.json();

            if (response.status >= 400 && response.status < 600) {
                throw (new Error(errorString(response)))
            }

            // console.log('all airport portal json ', json)
            resolve(json);

        } catch (e) {
            reject(new Error("error getting two airport bookings"));
        }
    });
};

export const getTwoAirportBookingsApp = async (props) => {

    const token = await getToken();

    const url = "/api/v1/bookings/bookingAnalytics/" +
        props.departureAirport +
        "/counts?date=" +
        props.startDate +
        "&endDate=" +
        props.endDate +
        "&type=two_airports&range=year&byType=A&airline=&endDate=&byHour=&source=A&byFlight=&forecast=&destinationAirport=" +
        props.arrivalAirport

    // console.log('getting app app ', url);

    return new Promise(async (resolve, reject) => {

        try {
            const response = await fetch(url, { method: 'GET', headers: { "Firebase-UID": token } });
            let json = await response.json();

            if (response.status >= 400 && response.status < 600) {
                throw (new Error(errorString(response)))
            }

            // console.log('all airport app bookings ', json)
            resolve(json);

        } catch (e) {
            console.log('error ', e)
            reject(new Error("error getting two airport bookings"));
        }
    });
};

export const getTwoAirportBookingsSita = async (props) => {

    const token = await getToken();

    const url = "/api/v1/bookings/bookingAnalytics/" +
        props.departureAirport +
        "/counts?date=" +
        props.startDate +
        "&endDate=" +
        props.endDate +
        "&type=two_airports&range=year&byType=A&airline=&endDate=&byHour=&source=S&byFlight=&forecast=&destinationAirport=" +
        props.arrivalAirport

    // console.log('getting app app ', url);

    return new Promise(async (resolve, reject) => {

        try {
            const response = await fetch(url, { method: 'GET', headers: { "Firebase-UID": token } });
            let json = await response.json();

            if (response.status >= 400 && response.status < 600) {
                throw (new Error(errorString(response)))
            }

            // console.log('all airport app bookings ', json)
            resolve(json);

        } catch (e) {
            console.log('error ', e)
            reject(new Error("error getting two airport bookings"));
        }
    });
};

export const getTwoAirportBookingsAll = async (props) => {

    const token = await getToken();

    const url = "/api/v1/bookings/bookingAnalytics/" +
        props.departureAirport +
        "/counts?date=" +
        props.startDate +
        "&endDate=" +
        props.endDate +
        "&type=two_airports&range=year&byType=A&airline=&endDate=&byHour=&source=none&byFlight=&forecast=&destinationAirport=" +
        props.arrivalAirport

    // console.log('getting app portal and sita bookings ', url);

    return new Promise(async (resolve, reject) => {

        try {
            const response = await fetch(url, { method: 'GET', headers: { "Firebase-UID": token } });
            let json = await response.json();

            if (response.status >= 400 && response.status < 600) {
                throw (new Error(errorString(response)))
            }

            // console.log('all airport app sita and portal ', json)
            resolve(json);

        } catch (e) {
            console.log('error ', e)
            reject(new Error("error getting two airport bookings"));
        }
    });
};

function generateMonthList(startDate, endDate, departureAirport, arrivalAirport, source) {
    const monthList = [];
    let currentDate = new Date(startDate);

    while (currentDate <= endDate) {
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const startOfMonth = `${year}-${month}-01`;
        const endOfMonth = `${year}-${month}-${new Date(year, currentDate.getMonth() + 1, 0).getDate()}`;
        const url = "/api/v1/bookings/bookingAnalytics/" + departureAirport + "/counts?date=" + startOfMonth + "&endDate=" + endOfMonth + "&type=two_airports&range=year&byType=none&airline=&endDate=&byHour=&source=" + source + "&byFlight=&forecast=&destinationAirport=" + arrivalAirport

        monthList.push(
            url
        );

        currentDate.setMonth(currentDate.getMonth() + 1);
    }

    return monthList;
}

function generateMonthStringList(startDate, endDate) {
    const monthList = [];
    let currentDate = new Date(startDate);

    while (currentDate <= endDate) {
        const month = currentDate.toLocaleString('default', { month: 'long', year: 'numeric' });
        monthList.push(month);
        currentDate.setMonth(currentDate.getMonth() + 1);
    }

    return monthList;
}

export const getTwoAirportMonthlyBookings = async (props) => {

    const endpointsUrls = generateMonthList(props.startMonth, props.endMonth, props.departureAirport, props.arrivalAirport, props.filter);
    const monthList = generateMonthStringList(props.startMonth, props.endMonth);

    const token = await getToken();

    let flightType = props.type;
    let bookingFilter = props.filter;

    return new Promise(async (resolve, reject) => {
        const counts = [];

        // Use Promise.all to send all requests at once and wait for all responses
        Promise.all(endpointsUrls.map(url => fetch(url, { method: 'GET', headers: { "Firebase-UID": token } })))
            .then(responses => Promise.all(responses.map(res => res.json())))
            .then(data => {

                // Concatenate all counts into a single array
                data.forEach((count, index) => {
                    // get count using key
                    let key = Object.keys(count)
                    let bookings = 0;

                    if (key.length == 0) { bookings = 0 }
                    else { bookings = count[key[0]] }

                    counts.push({
                        bookingCount: bookings,
                        month: monthList[index],
                        type: bookingFilter,
                        flightType: flightType
                    })
                });

                // console.log(flightType + ' Graph Counts ', counts);
                resolve(counts);

            })
            .catch(error => reject(error));
    });
};



export const getTopAirportRanking = async (props = {}) => {
    const queryParams = new URLSearchParams({
        type: "top_airports",
        range: "year",
        byType: "none",
        airline: "",
        reduce: "true",
        byHour: "",
        byFlight: "",
        forecast: "",
        date: "2019-01-01",
    });

    if (props?.limit != null) queryParams.set("limit", 10000);
    queryParams.set("skip", 0);

    const url = "/api/v1/bookings/bookingAnalytics/" + props.departureAirport + "/counts?" + queryParams.toString()
    const token = await getToken();


    // console.log('endpoints url ', endpointsUrls)
    return new Promise(async (resolve, reject) => {

        try {
            const response = await fetch(url, { method: 'GET', headers: { "Firebase-UID": token } });
            let json = await response.json();

            if (response.status >= 400 && response.status < 600) {
                throw (new Error(errorString(response)))
            }

            console.log('all airport app sita and portal ', json)
            resolve({
                rankings: json?.docs ?? json?.rankings ?? json?.data ?? json,
                totalRows: json?.total_rows ?? json?.totalRows ?? json?.total ?? json?.count ?? Object.keys(json?.docs ?? json?.rankings ?? json?.data ?? json ?? {}).length
            });

        } catch (e) {
            console.log('error ', e)
            reject(new Error("error getting two airport bookings"));
        }
    });
};



export const getPreNotifiedBookings = async (props) => {

    const token = await getToken();

    const url = "/api/v1/bookings/bookingAnalytics/" +
        props.departureAirport +
        "/counts?date=" +
        props.startDate +
        "&endDate=" +
        props.endDate +
        "&type=two_airports&airline=&endDate=&byHour=&source="
        + props.filter +
        "&byFlight=&forecast=&destinationAirport=" +
        props.arrivalAirport
        + "&pre_advised=" + (props.preNotified ? 'true' : 'false')

    return new Promise(async (resolve, reject) => {

        try {
            const response = await fetch(url, { method: 'GET', headers: { "Firebase-UID": token } });
            let json = await response.json();

            if (response.status >= 400 && response.status < 600) {
                throw (new Error(errorString(response)))
            }

            resolve(json);

        } catch (e) {
            console.log('error ', e)
            reject(new Error(e.message));
        }
    });
};


// get reviews list 
export const getGlobalScores = async (props = {}) => {

    const token = await getToken();
    const queryParams = new URLSearchParams();

    if (props?.departureAirport) {
        queryParams.set("iata", props.departureAirport);
        queryParams.set("startDate", props.startDate || "2019-01-01");
        if (props?.endDate) queryParams.set("endDate", props.endDate);
    }

    if (props?.limit != null) queryParams.set("limit", props.limit);
    if (props?.skip != null) queryParams.set("skip", props.skip);

    const url = props?.departureAirport
        ? "/api/v1/review/statistics/relationship-averages?" + queryParams.toString()
        : "/api/v1/review/statistics/averages/" + (queryParams.toString() ? `?${queryParams.toString()}` : "")

    return new Promise(async (resolve, reject) => {

        try {
            const response = await fetch(url, { method: 'GET', headers: { "Firebase-UID": token } });
            let json = await response.json();

            if (response.status >= 400 && response.status < 600) {
                throw (new Error(errorString(response)))
            }
            resolve({
                docs: json?.docs ?? [],
                totalRows: json?.total_rows ?? json?.totalRows ?? json?.total ?? json?.count ?? json?.docs?.length ?? 0
            });

        } catch (e) {
            reject(new Error("Error getting reviews list"));
        }
    });
};

export const getAirportInformation = async (iata) => {

    const token = await getToken();
    const url = "/api/v1/bookings/airports/" + iata
    return new Promise(async (resolve, reject) => {

        try {
            const response = await fetch(url, { method: 'GET', headers: { "Firebase-UID": token } });
            let json = await response.json();

            if (response.status >= 400 && response.status < 600) {
                throw (new Error(errorString(response)))
            }

            resolve(json);

        } catch (e) {
            reject(new Error("Error getting reviews list"));
        }
    });
};

export const getAverageDueTime = async (props) => {

    const token = await getToken();
    const url = "/api/v1/bookings/bookingAnalytics/" +
        props.departureAirport +
        "/counts?date=" +
        props.startDate +
        "&endDate=" +
        props.endDate +
        "&type=two_airports&range=year&byType=none&airline=&endDate=&byHour=&source=" +
        props.filter +
        "&byFlight=&forecast=&destinationAirport=" +
        props.arrivalAirport +
        "&breakDownByRequest=destination_requested&dueTime=true"

    return new Promise(async (resolve, reject) => {

        try {
            const response = await fetch(url, { method: 'GET', headers: { "Firebase-UID": token } });
            let json = await response.json();

            if (response.status >= 400 && response.status < 600) {
                throw (new Error(errorString(response)))
            }

            resolve(json);

        } catch (e) {
            reject(new Error("Error getting reviews list"));
        }
    });
};

export const getScoreCard = async (params) => {

    const token = await getToken();

    /*if(props.allBookings == true){
        url = "/api/v1/review/reviews/reviewStats?code=" + props.iata + "&reduce=false&queryType=scoreCard&include_docs=true"
    }
    else {
        url = "/api/v1/review/reviews/reviewStats?code=" + props.iata + "&startDate=" + props.startDate + "&endDate=" + props.endDate + "&reduce=false&queryType=scoreCard&include_docs=true"
    }*/

    let url = '';

    if (params.allBookings == false) {
        url = "/api/v1/review/reviews/reviewStats?code=" + params.iata + "&startDate=" + params.startDate + "&endDate=" + params.endDate + "&reduce=false&queryType=scoreCard&include_docs=true&limit=1000"
    } else {
        url = "/api/v1/review/reviews/reviewStats?code=" + params.iata + "&reduce=false&queryType=scoreCard&include_docs=true&limit=1000"
    }


    return new Promise(async (resolve, reject) => {

        try {
            const response = await fetch(url, { method: 'GET', headers: { "Firebase-UID": token } });
            let json = await response.json();

            if (response.status >= 400 && response.status < 600) {
                throw (new Error(errorString(response)))
            }

            resolve(json);

        } catch (e) {
            reject(new Error("Error getting reviews list"));
        }
    });
};

export const getAirportImage = async (iata) => {
    const storage = getStorage();
    const extensions = ["jpg", "jpeg", "png"];
    //There are files/images with multiple extension, not only jpg
    for (const ext of extensions) {
        const pathReference = ref(storage, `images/airports/${iata}.${ext}`);
        try {
            const url = await getDownloadURL(pathReference);

            return url;
        } catch (error) {
            if (error.code === "storage/object-not-found") {
                // Try next extension
                continue;
            } else {
                // Other storage error — stop trying
                console.error("Error getting airport image:", error);
                throw error;
            }
        }
    }

    throw new Error(`No image found for airport ${iata} with extensions: ${extensions.join(", ")}`);
};


export const getAirportLogo = async (iata) => {

    const storage = getStorage();

    return new Promise((resolve, reject) => {

        const pathReference = ref(storage, `images/logos/${iata}`)

        getDownloadURL(pathReference)
            .then((url) => {
                resolve(url)
            })
            .catch(async (error) => {
                console.log('error ', error)
                reject(
                    new Error(
                        reject(new Error(error))
                    )
                )
            });


    })
}
export const getAirportBase64Logo = async (iata) => {
    const token = await getToken();
    let url = '/api/v1/bookings/airports/logo/' + iata
    return new Promise(async (resolve, reject) => {
        try {
            const response = await fetch(url, { method: 'GET', headers: { "Firebase-UID": token } });
            let json = await response.json();
            if (response.status >= 400 && response.status < 600) {
                throw (new Error(errorString(response)))
            }
            resolve(json);
        } catch (e) {
            reject(new Error("Error getting reviews list"));
        }
    })
}


export const UploadAirportLogoService = async (data) => {
    var storage = fire.storage();

    return new Promise(async (resolve, reject) => {
        // create reference
        const uploadTask = storage.ref(`images/logos/${data.iata}`).put(data.image);

        uploadTask.on(
            "state_changed",
            (snapShot) => {
                // update on progress of upload
            },
            (e) => {
                reject(new Error("Issue uploading Image"));
            },
            () => {
                // upload complete
                storage
                    .ref("images/logos")
                    .child(data.iata)
                    .getDownloadURL()
                    .then((fireBaseUrl) => {
                        resolve(fireBaseUrl);
                    });
            }
        );
    });
};



export const getWaitingTimes = async (params) => {
    const token = await getToken();
    let url = `/api/v1/bookings/bookingAnalytics/${params.iata}/waitingTimes?csv=${params.csv || false}&type=${params.type}&taskType=${params.taskType ?? "all"}`;


    return new Promise(async (resolve, reject) => {

        try {
            const response = await fetch(url, { method: 'GET', headers: { "Firebase-UID": token } });
            const json = await response.json();

            if (response.status >= 400 && response.status < 600) {
                throw (new Error(errorString(response)))
            }

            resolve(json);

        } catch (e) {
            reject(new Error("Error getting reviews list"));
        }
    });
};


export const changeEmail = async (email) => {
    return new Promise((resolve, reject) => {
        fire
            .auth()
            .currentUser.updateEmail(email)
            .then(() => {
                // updated sucessfully
                resolve();
            })
            .catch(async (error) => {
                if (error.code === "auth/requires-recent-login") {
                    reject(
                        new Error(
                            "Error. Please log out and log back in to change your account information"
                        )
                    );
                }
                if (error.code === "auth/email-already-in-use") {
                    reject(new Error("This email is already in use"));
                } else {
                    reject(new Error("Error changing email. Please try again later."));
                }
            });
    });
};
